// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1p-Ol","icon":"SortAdornment_icon__2oW53","up":"SortAdornment_up__wcrYU","down":"SortAdornment_down__1G60g","active":"SortAdornment_active__2LoJB"};